export default "__VITE_ASSET__34KXZg2i__"